/** A typo'd key is a cache that never invalidates — here, a doctor reading last
 *  month's prescription believing it is today's. */
export const queryKeys = {
  me: ['me'] as const,
  search: (q: string) => ['search', q] as const,
  patient: (id: string) => ['patient', id] as const,
  visits: (patientId: string) => ['patient', patientId, 'visits'] as const,
  visit: (id: string) => ['visit', id] as const,
  thumbnail: (attachmentId: string) => ['attachment', attachmentId, 'thumbnail'] as const,
  recentPatients: ['recent-patients'] as const,
  patientList: (limit: number) => ['patients', 'recent', limit] as const,
  prescriptions: (q: string) => ['prescriptions', q] as const,
  callers: (status: string, q: string) => ['callers', status, q] as const,
  caller: (id: string) => ['caller', id] as const,
  callersDue: ['callers', 'due'] as const,
  callerCounts: ['callers', 'counts'] as const,
  travel: (from: string, to: string) => ['travel', from, to] as const,
  travelLocations: ['travel', 'locations'] as const,
  calendar: (from: string, to: string) => ['calendar', from, to] as const,
}
